import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from './assets/techwise-logo.png';

const Signup: React.FC = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [responseMsg, setResponseMsg] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const BACKEND_URL = "https://gln7w8w5uc.execute-api.ap-south-1.amazonaws.com/dev";
  //const BACKEND_URL = "http://localhost:5000";


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setError('');
    setResponseMsg('');
    try {
      const res = await fetch(`${BACKEND_URL}/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, password }),
      });
      if (!res.ok) throw new Error('Signup failed');
      const data = await res.json();
      setResponseMsg(data.message || 'Signup successful!');
    } catch (err: any) {
      setError(err.message || 'Signup failed');
    }
  };

  return (
    <div
      style={{
        maxWidth: 400,
        margin: '2rem auto',
        padding: 20,
        background: 'var(--background-color)',
        borderRadius: 8,
        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
      }}
    >
      {/* Header with Logo */}
      <header style={{ display: 'flex', justifyContent: 'center', paddingBottom: 20 }}>
        <img src={logo} alt="TechWise Logo" style={{ height: 40 }} />
      </header>

      <h2 style={{ textAlign: 'center', marginBottom: 20, color: 'var(--primary-color)' }}>Sign Up</h2>

      {submitted && responseMsg && (
        <div style={{ color: 'green', marginBottom: 12, textAlign: 'center' }}>
          {responseMsg}
        </div>
      )}
      {error && (
        <div style={{ color: 'red', marginBottom: 12, textAlign: 'center' }}>
          {error}
        </div>
      )}

      {(!submitted || !responseMsg) && (
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 12 }}>
            <label htmlFor="name" style={{ display: 'block', marginBottom: 4 }}>Name:</label>
            <input
              id="name"
              type="text"
              value={name}
              onChange={e => setName(e.target.value)}
              style={{
                width: '92%',
                padding: '12px 16px',
                borderRadius: 4,
                border: '1px solid #ccc',
                fontSize: 16,
              }}
            />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label htmlFor="email" style={{ display: 'block', marginBottom: 4 }}>Email:</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              style={{
                width: '92%',
                padding: '12px 16px',
                borderRadius: 4,
                border: '1px solid #ccc',
                fontSize: 16,
              }}
            />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label htmlFor="password" style={{ display: 'block', marginBottom: 4 }}>Password:</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              style={{
                width: '92%',
                padding: '12px 16px',
                borderRadius: 4,
                border: '1px solid #ccc',
                fontSize: 16,
              }}
            />
          </div>
          <button
            type="submit"
            style={{
              width: '100%',
              padding: '12px 16px',
              borderRadius: 4,
              border: '1px solid #ccc',
              background: '#fff',
              color: '#C54040',
              fontWeight: 'bold',
              fontSize: 16,
              cursor: 'pointer',
            }}
          >
            Create Account
          </button>
        </form>
      )}
      <div style={{ marginTop: 16, textAlign: 'center' }}>
        <button
          onClick={() => navigate('/signin')}
          style={{
            background: 'none',
            border: 'none',
            color: '#000000ff',
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
        >
          Back to Sign In
        </button>
      </div>
    </div>
  );
};

export default Signup;
